<template>
    <div class="int-join-ms-wrap" v-if="initAt">
        <div class="int-join-top">
            <a href="javascript:;">
                <div class="img-com join-member-logo"><span>로고</span></div>
            </a>
            <a href="javascript:;" style="position:absolute;top:52px;right:0px;" @click="btn_mainClick()" v-if="joinCours != 'I5GAMTMP'">메인페이지로 이동</a>
        </div>
        <section class="int-join-ms join-stage">
            <div class="join-stage-top">
                <h1>회원가입</h1>
                <ul class="join-location">
                    <li v-if="mode!='joinAgree'"><div class="join-stage"><span class="blind">STEP1. 가입약관동의</span></div></li>
                    <li v-if="mode=='joinAgree'"><div class="join-stage on"><span class="blind">현재단계</span></div><div class="join-stage-txt">STEP1. 가입약관동의</div></li>
                    <li v-if="mode!='joinInfo'"><div class="join-stage"><span class="blind">STEP2. 정보입력</span></div></li>
                    <li v-if="mode=='joinInfo'"><div class="join-stage on"><span class="blind">현재단계</span></div><div class="join-stage-txt">STEP2. 정보입력</div></li>
                    <li><div class="join-stage"><span class="blind">STEP3. 가입완료</span></div></li>
                </ul>
                <div class="entry-txt" v-if="mode=='joinAgree'">이용약관 및 정보 수신에 동의 해주세요.</div>
                <div class="entry-txt" v-if="mode=='joinInfo'">기본 정보를 모두 입력하면 가입이 완료됩니다.</div>
            </div>
            <div class="join-stage-con">
                <template v-if="mode == 'joinAgree'">
                <div class="all-checkbox">
                    <input type="checkbox" id="chk00" v-model="rcptnAgreeInfo.allAgreeAt" @change="rcptnAgreeChange('all')">
                    <label for="chk00" style="margin-left:0px;"><span class="box"></span><span class="label-txt">약관ㆍ정보 수신 모두 동의</span></label>
                </div>
                <h2>이용약관, 개인정보 수집/이용 동의</h2>
                <ul class="join-stage-consent">
                    <li>
                        <input type="checkbox" id="chk01" name="" v-model="rcptnAgreeInfo.tosAgreeAt" @change="rcptnAgreeChange('tos')">
                        <label for="chk01"><span class="box"></span><span class="label-txt"><span class="pc01">(필수)</span> 이용약관 동의</span></label>
                        <button class="btn-f15" @click="openTosAgreePopup();">자세히보기</button>
                    </li>
                    <li>
                        <input type="checkbox" id="chk02" name="" v-model="rcptnAgreeInfo.pcuAgreeAt" @change="rcptnAgreeChange('pcu')">
                        <label for="chk02"><span class="box"></span><span class="label-txt"><span class="pc01">(필수)</span> 개인정보 수집ㆍ이용 동의</span></label>
                        <button class="btn-f15" @click="openPcuAgreePopup();">자세히보기</button>
                        </li>
                    <li>
                        <input type="checkbox" id="chk03" name="" v-model="rcptnAgreeInfo.ptoAgreeAt" @change="rcptnAgreeChange('pto')">
                        <label for="chk03"><span class="box"></span><span class="label-txt"><span class="pc01">(필수)</span> 개인정보 제3자 제공 동의</span></label>
                        <button class="btn-f15" @click="openPtoAgreePopup();">자세히보기</button>
                    </li>
                </ul>
                <div class="join-stage-bottom">
                    <div class="img-com __join-info"><span>설명글 아이콘</span></div>동의하지 않으실 경우 <span class="pc01">서비스 이용이 불가능</span>합니다.
                </div>
                <h2>보육 업무ㆍ회계/세무에 대한 다양한 정보 및 혜택 수신 동의</h2>
                <ul class="join-stage-consent">
                    <li>
                        <input type="checkbox" id="chk04" name="" v-model="rcptnAgreeInfo.smsAgreeAt" @change="rcptnAgreeChange('sms')">
                        <label for="chk04"><span class="box"></span><span class="label-txt">SMS 수신 동의</span></label>
                    </li>
                    <li>
                        <input type="checkbox" id="chk05" name="" v-model="rcptnAgreeInfo.emailAgreeAt" @change="rcptnAgreeChange('email')">
                        <label for="chk05"><span class="box"></span><span class="label-txt">이메일 수신 동의 </span></label>
                    </li>
                </ul>
                </template>

                <template v-if="mode=='joinInfo'">
                    <div class="join-stage-input">
                        <input type="text" placeholder="아이디" title="아이디"
                               v-model="mberInfo.id" maxlength="12"
                               @keyup.space="spaceKeyUp('id')"
                               @keydown.delete="cancelidOvrlpChk"
                               @keypress="cancelidOvrlpChk"/>
                        <button :class="setBtnClass('id')"
                                @click="btn_idOvrlpClick">중복확인</button>
                    </div>
                    <div class="join-stage-bottom">
                        <div class="img-com __join-info"><span>설명글 아이콘</span></div>영문,숫자 조합으로 6~12자 이내
                    </div>
                    <div class="join-stage-input">
                        <input type="password" placeholder="비밀번호" title="비밀번호"
                               ref="password"
                               v-model="mberInfo.password" maxlength="15"
                               @keyup.space="spaceKeyUp('pw')"
                               @focusout="focusOutPasswd()"/>
                    </div>
                    <div class="join-stage-input">
                        <input type="password" placeholder="비밀번호 확인" title="비밀번호 확인"
                               v-model="mberInfo.passwordChk" maxlength="15"
                               @keyup.space="spaceKeyUp('pwChk')"/>
                    </div>
                    <div class="join-stage-bottom">
                        <div class="img-com __join-info"><span>설명글 아이콘</span></div>8-15자리의 영문/숫자/특수문자를 함께 입력해주세요
                    </div>
                    <div class="join-stage-input">
                        <input type="text" placeholder="성명" title="성명" v-model="mberInfo.mberNm"/>
                    </div>
                    <div class="join-stage-input">
                        <div class="join-stage-box">
                            <select v-model="mberInfo.cttpc1"
                                    :disabled="phoneCrtfctn.time > 0"
                                    @change="cancelchkCrtfy()">
                                <option>010</option>
                                <option>011</option>
                                <option>016</option>
                                <option>017</option>
                                <option>018</option>
                                <option>019</option>
                            </select>
                            <input type="text" class="mgr10" v-model="mberInfo.cttpc2" maxlength="4"
                                   :disabled="phoneCrtfctn.time > 0"
                                   :style="{'color':phoneCrtfctn.time > 0?'gray':'black'}"
                                   @keyup="$onbiLib.onlyNumberKeyup()"
                                   @keydown="$onbiLib.onlyNumberKeydown()"
                                   @change="cancelchkCrtfy()"/> -
                            <input type="text" class="mgl10" v-model="mberInfo.cttpc3" maxlength="4"
                                   :disabled="phoneCrtfctn.time > 0"
                                   :style="{'color':phoneCrtfctn.time > 0?'gray':'black'}"
                                   @keyup="$onbiLib.onlyNumberKeyup()"
                                   @keydown="$onbiLib.onlyNumberKeydown()"
                                   @change="cancelchkCrtfy()"/>
                        </div>
                        <button :class="setBtnClass('btn_sendNum')"
                                ref="btn_sendNum"
                                @click="btn_crtfctnClick()">
                          <template v-if="clickCnt == 0">인증</template>
                          <template v-if="clickCnt > 0">재인증</template>
                        </button>
                    </div>
                    <div class="join-stage-input">
                        <input type="text" placeholder="인증번호 입력(3분 이내)" title="인증번호"
                               v-model="mberInfo.crtfyNum" ref="crtfyNum" maxlength="6"
                               :disabled="phoneCrtfctn.timer == null || phoneCrtfctn.time==0"
                               :style="{'background':phoneCrtfctn.timer == null||phoneCrtfctn.time==0?'#f8f8f8':'#fff'}"
                               @keyup="$onbiLib.onlyNumberKeyup()"
                               @keydown="$onbiLib.onlyNumberKeydown()"/>
                        <span>{{setTimerShow}}</span>
                        <button :class="setBtnClass('btn_crtfy')" ref="btn_crtfy"
                                @click="btn_cnfrmNumClick()">확인</button>
                    </div>
                    <div class="join-stage-input mgt20">
                        <input type="text" placeholder="이메일" title="이메일" v-model="mberInfo.email"/>
                    </div>
                </template>
            </div>
            <div class="btn-wrap __btn-join" v-if="mode=='joinAgree'">
            <template v-if="joinCours == 'I5GAMTMP'">
                <div class="dp-td" style="width:100%;"><button class="red" @click="btn_nextClick()">다음</button></div>
            </template>
            <template v-if="joinCours != 'I5GAMTMP'">
                <div class="dp-td"><button class="white" @click="btn_cancelClick()">취소</button></div>
                <div class="dp-td" v-if="mode=='joinAgree'" style="width:100%;"><button class="red" @click="btn_nextClick()">다음</button></div>
            </template>
            </div>
            <div class="btn-wrap __btn-join" id="buttonArea"
                 @mouseover="focusOut()" @mouseout="focusOn()" v-if="mode=='joinInfo'">
                <div class="dp-td"><button class="white" @click="btn_cancelClick()">취소</button></div>
                <div class="dp-td"><button class="red" @click="btn_joinClick()">가입하기</button></div>
            </div>
        </section>
    </div>
</template>

<script>
    const mixinAgree = {
        data : function(){
            return {
                rcptnAgreeInfo : {
                    allAgreeAt:false,
                    tosAgreeAt:false,//Terms of Service - 서비스 약관(이용약관)
                    pcuAgreeAt:false,//Privacy CollectionㆍUse - 개인정보 수집ㆍ이용
                    ptoAgreeAt:false,//Privacy Third party offer - 개인정보 제3자 제공
                    smsAgreeAt:false,
                    emailAgreeAt:false
                }
            }
        },
        methods : {
            rcptnAgreeChange : function(agreeSe){
                const agreeAt = eval("this.rcptnAgreeInfo." + agreeSe + "AgreeAt");

                if(agreeSe == "all"){
                    for(const key in this.rcptnAgreeInfo){
                        if(key != "allAgreeAt"){
                            this.rcptnAgreeInfo[key] = agreeAt;
                        }
                    }
                }else{
                    let chkCnt = 0;

                    for(const key in this.receptionAgree){
                        if(key != "allAgreeAt"){
                            if(this.rcptnAgreeInfo[key]) chkCnt++;
                        }
                    }

                    if(chkCnt == (Object.keys(this.rcptnAgreeInfo).length-1)){
                        this.rcptnAgreeInfo.allAgreeAt = true;
                    }else{
                        this.rcptnAgreeInfo.allAgreeAt = false;
                    }
                }
            },
            openTosAgreePopup : function(){
                const popupInfo = {
                    se:'modal',
                    id:'tosAgreePopup',
                    wid:'700',
                    hei:'',
                    tit:'이용약관 동의',
                    draggableAt:true,
                    param:null
                };

                this.$store.commit('openPopup',popupInfo);
            },
            openPcuAgreePopup : function(){
                const popupInfo = {
                    se:'modal',
                    id:'pcuAgreePopup',
                    wid:'700',
                    hei:'',
                    tit:'개인정보 수집ㆍ이용 동의',
                    draggableAt:true,
                    param:null
                };

                this.$store.commit('openPopup',popupInfo);
            },
            openPtoAgreePopup : function(){
                const popupInfo = {
                    se:'modal',
                    id:'ptoAgreePopup',
                    wid:'700',
                    hei:'',
                    tit:'개인정보 제3자 제공 동의',
                    draggableAt:true,
                    param:null
                };

                this.$store.commit('openPopup',popupInfo);
            },
            btn_nextClick: function(){
                if(!(this.rcptnAgreeInfo.tosAgreeAt &&this.rcptnAgreeInfo.pcuAgreeAt &&this.rcptnAgreeInfo.ptoAgreeAt)){
                    this.$toasted.show("이용약관, 개인정보 수집ㆍ이용, 제3자 제공에 대한 안내 모두 동의해주세요.");
                    return false;
                }

                this.mode = 'joinInfo';
            }
        }
    }

    const mixinInfo = {
        computed: {
          setTimerShow: function () {
            if (this.phoneCrtfctn.timer == null) return '--:--';
            else {
              let min = Math.floor(this.phoneCrtfctn.time / 60);
              let sec = this.phoneCrtfctn.time % 60;
              if (sec < 10) {
                sec = '0' + sec
              }
              if (min == 0 && sec == 0) {
                return '--:--';
              }
              return min + ':' + sec;
            }
          },
        },
        data : function(){
            return {
                mberInfo : {
                    mberNo : '',
                    mberNm : '',
                    id : '',
                    password : '',
                    passwordChk : '',
                    cttpc1 : '010',
                    cttpc2 : '',
                    cttpc3 : '',
                    cttpc : '',
                    chkCrtfy : false,	//휴대폰 인증 체크
                    crtfyNum : '',
                    email : '',
                    idOvrlpChkAt : false,			//중복 아이디 체크
                },
              focusAt: true,
              phoneCrtfctn: {
                timer: null,
                time: 0,
                cttpc1: '',
                cttpc2: '',
                cttpc3: '',
              },
              clickCnt: 0,// 인증시도 횟수
              def:{
                phoneCrtfctn: {
                  timer: null,
                  time: 0,
                  cttpc1: '',
                  cttpc2: '',
                  cttpc3: '',
                },
              }
            }
        },
        methods : {
            validId : function(){   //아이디 유효성 체크
                this.mberInfo.id = this.mberInfo.id.replaceAll(' ', '');

                if(this.mberInfo.id == ''){
                    this.$toasted.show("아이디를 입력해주세요.");
                    return false;
                }

                //한글확인
                const korExp = /([ㄱ-ㅎㅏ-ㅣ가-힣])/i;
                if(korExp.test(this.mberInfo.id)){
                    this.$toasted.show("한글은 입력 불가합니다.\n영문, 숫자조합으로 6~12자 이내로 입력해주세요.");
                    return false;
                }

                const spcExp = /[~!@#$%^&*()_+|<>?:{}]/;
                if(!/^[a-zA-Z0-9]/g.test(this.mberInfo.id) ||
                    spcExp.test(this.mberInfo.id)||
                   this.mberInfo.id.length < 6||
                   this.mberInfo.id.length > 12){
                    this.$toasted.show('영문, 숫자 조합으로 6~12자 이내로 입력해주세요.');
                    return false;
                }

                return true;
            },
            btn_idOvrlpClick : function(){  //아이디 중복확인 클릭
                if(this.setBtnClass('id') == 'deagi')return false;

                if(!this.validId()) return false;

                this.axios.post('/i5gam/member/join/idOvrlpChk.act',{
                    id:this.mberInfo.id
                }).then(function(response) {
                    if(response.data.ovrlpAt == "Y"){
                        this.$toasted.show('이미 사용중인 아이디입니다.');
                    }else{
                        this.mberInfo.idOvrlpChkAt = true;
                        this.$toasted.show('사용가능한 아이디 입니다.',{duration:1000,type:"success"});
                    }
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    this.$toasted.show(this.$onbiLib.msg.err.system);
                }.bind(this));
            },
            btn_crtfctnClick : function(){  //인증버튼 클릭
                if(this.setBtnClass('btn_sendNum') == 'deagi')return false;

                if(this.mberInfo.cttpc1 == this.phoneCrtfctn.cttpc1&&
                    this.mberInfo.cttpc2 == this.phoneCrtfctn.cttpc2&&
                    this.mberInfo.cttpc3 == this.phoneCrtfctn.cttpc3){
                  this.$toasted.show('이미 인증된 휴대폰번호 입니다.');
                  return false;
                }
                if(this.mberInfo.cttpc2 == '' || this.mberInfo.cttpc3.length == ''){
                    this.$toasted.show('휴대폰번호를 입력해주세요.');
                    return false;
                }

                if(this.mberInfo.cttpc2.search(/^\d{3,4}$/) === -1 || this.mberInfo.cttpc3.search(/^\d{4}$/) === -1){
                    this.$toasted.show("숫자만 입력 가능합니다.");
                    this.mberInfo.cttpc2 = '';
                    this.mberInfo.cttpc3 = '';
                    return false;
                }

                this.phoneJoinMberChk().then(function(joinPssbleAt){//폰번호당 아이디 5개만 가입 가능
                    if(joinPssbleAt == 'Y'){
                        this.phoneCrtfyNumSend();
                    }else{
                        this.$toasted.show('입력하신 휴대폰 번호로 가입한 ID가 5개 이상입니다.');
                        return false;
                    }
                }.bind(this)).catch(function (e) {
                    console.log(e);
                    this.$toasted.show(this.$onbiLib.msg.err.system);
                }.bind(this));
            },
            phoneJoinMberChk : function(){ 
                return new Promise(function (resolve, reject) {
                    this.axios.post('/i5gam/member/join/phoneJoinMberChk.act',{
                        cttpc : this.mberInfo.cttpc1 + "-" + this.mberInfo.cttpc2 + "-" + this.mberInfo.cttpc3
                    }).then(function(response) {
                        const joinPssbleAt = response.data.joinPssbleAt;
                        resolve(joinPssbleAt);
                    }.bind(this)).catch(function(e) {
                        reject(e);
                    });
                }.bind(this));
            },
            phoneCrtfyNumSend : function(){ //인증번호 전송
              if(this.phoneCrtfctn.time > 0) return false;

              this.axios.post('/common/crtfy/phoneCrtfyNumSend.act',{
                    cttpc : this.mberInfo.cttpc1 + "-" + this.mberInfo.cttpc2 + "-" + this.mberInfo.cttpc3,
                    srvcCd : 'SBIW02'
                }).then(function(){
                    this.clickCnt += 1;
                    this.$toasted.show('인증번호를 발송했습니다. 인증번호가 오지 않으면 입력하신 정보가 정확한지 확인해주세요. 발송된 인증번호는 3분간 유효합니다.', {duraion:1000, type:"info"});
                    //3분 타이머 설정
                    this.setCrtfctnTimer();

                    this.$refs.crtfyNum.focus();
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    this.$toasted.show(this.$onbiLib.msg.err.system);
                }.bind(this));
            },
            setCrtfctnTimer : function(){   //타이머 설정
                this.mberInfo.chkCrtfy = false;
                this.mberInfo.crtfyNum = '';
                clearInterval(this.phoneCrtfctn.timer);

                //타이머 설정
                this.phoneCrtfctn.time = 180;
                this.phoneCrtfctn.timer = setInterval(function(){
                  if(this.phoneCrtfctn.time == 0){
                    this.mberInfo.chkCrtfy = false;
                    this.mberInfo.crtfyNum = '';
                    this.$toasted.show('인증번호 유효시간이 만료되었습니다. 다시 인증해주세요.');
                    clearInterval(this.phoneCrtfctn.timer);
                  }else{
                    this.phoneCrtfctn.time--;
                  }
                }.bind(this), 1000);
            },
            btn_cnfrmNumClick : function(){ //인증번호 확인 버튼
                if(this.setBtnClass('btn_crtfy') == 'deagi')return false;

                if(this.mberInfo.crtfyNum == ''){
                    this.$toasted.show('인증번호를 입력하지 않았습니다. 수신한 인증번호를 입력해주세요.');
                    return false;
                }

                if(this.mberInfo.crtfyNum.length != 6){
                    this.$toasted.show('인증번호를 6자리로 입력해주세요.');
                    return false;
                }

                this.axios.post('/common/crtfy/phoneCrtfyNumCnfrm.act',{
                    crtfyNum: this.mberInfo.crtfyNum,
                    cttpc : this.mberInfo.cttpc1 + "-" + this.mberInfo.cttpc2 + "-" + this.mberInfo.cttpc3,
                    mberNm : this.mberInfo.mberNm
                }).then(function(response) {
                    const crtfyNumChkCode = response.data.crtfyNumChkCode;
                    if(crtfyNumChkCode == '001'){
                        this.mberInfo.chkCrtfy = true;
                        this.$toasted.show('인증번호가 일치합니다.',{duration:1000,type:"info"});
                        clearInterval(this.phoneCrtfctn.timer);
                        this.phoneCrtfctn.cttpc1 = this.mberInfo.cttpc1;
                        this.phoneCrtfctn.cttpc2 = this.mberInfo.cttpc2;
                        this.phoneCrtfctn.cttpc3 = this.mberInfo.cttpc3;
                        this.phoneCrtfctn.time = 0;
                    }else if(crtfyNumChkCode == '998'){
                        this.$toasted.show('인증번호를 발송한 휴대폰 번호와 현재 입력된 휴대폰 번호가 다릅니다.');
                    }else if(crtfyNumChkCode == '999'){
                        this.$toasted.show('인증번호가 일치하지 않습니다. 입력한 휴대폰번호와 수신한 인증번호를 다시 한번 확인해주세요.');
                        this.mberInfo.crtfyNum = '';
                        this.$refs.crtfyNum.focus();
                    }
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    this.$toasted.show(this.$onbiLib.msg.err.system);
                }.bind(this));
            },
            cancelchkCrtfy: function (){
              if(this.mberInfo.chkCrtfy){
                if(this.mberInfo.cttpc1 != this.phoneCrtfctn.cttpc1||
                    this.mberInfo.cttpc2 != this.phoneCrtfctn.cttpc2||
                    this.mberInfo.cttpc3 != this.phoneCrtfctn.cttpc3){
                  this.mberInfo.chkCrtfy = false;
                  this.phoneCrtfctn = JSON.parse(JSON.stringify(this.def.phoneCrtfctn));
                  this.mberInfo.crtfyNum = '';
                }
              }
            },
            setBtnClass : function(btnSe){
              let cls = 'deagi'
              if(btnSe == 'id'){
                if(!this.mberInfo.idOvrlpChkAt && this.mberInfo.id.length >= 6) cls = 'act';
              }else if(btnSe=='btn_sendNum'){
                if(this.mberInfo.cttpc2.length >= 3
                    && this.mberInfo.cttpc3.length == 4 && this.phoneCrtfctn.time == 0) cls = 'act';
              }else if(btnSe == 'btn_crtfy'){
                if(this.mberInfo.crtfyNum.length == 6 && !this.mberInfo.chkCrtfy) cls = 'act';
              }

              return cls;
            },
            cancelidOvrlpChk: function (){
                if(!this.mberInfo.idOvrlpChkAt) return false;
                else {
                  this.mberInfo.idOvrlpChkAt = false;
                  this.setBtnClass('id');
                }
            },
            spaceKeyUp: function(info){
              this.$toasted.show('공백입력은 불가합니다.');
              if(info == 'id') this.mberInfo.id = this.mberInfo.id.replace(/ /gi,'');
              else if(info == 'pw') this.mberInfo.password = this.mberInfo.password.replace(/ /gi,'');
              else if(info == 'pwChk')this.mberInfo.passwordChk = this.mberInfo.passwordChk.replace(/ /gi,'');
            },
            focusOn: function (){
              this.focusAt = true;
            },
            focusOut: function (){
              this.focusAt = false;
            },
            focusOutPasswd: function (){
              if(!this.focusAt) return false;
              this.validPasswd();
            },
            validPasswd: function (){
              if (this.mberInfo.password.length > 0) {
                let chk = 0;
                if (this.mberInfo.password.search(/[0-9]/g) != -1) chk++;
                if (this.mberInfo.password.search(/[a-z]/ig) != -1) chk++;
                if (this.mberInfo.password.search(/[!@#$%^&*()?_~]/g) != -1) chk++;

                if ((chk < 3) || (this.mberInfo.password.length < 8 || this.mberInfo.password.length > 15)) {
                  this.$toasted.show("비밀번호는 영문, 숫자, 특수문자를 포함하여 8~15자로 생성해주세요.");
                  return false;
                }
              } else {
                this.$toasted.show("비밀번호를 입력해주세요.");
                return false;
              }
              //같은 문자 4번 제한
              if(!this.passwdRepeatKeyChk()) return false;

              //ID포함여부 체크
              if(!this.passwdIdChk()) return false;

              //연락처 포함여부 체크
              if(!this.passwdCttpcChk()) return false;

              //연속된 문자/숫자 정규식 생성
              if(!this.passwdCntnKeyChk()) return false;

              //잘알려진단어 체크
              if(!this.passwdKnownWordChk()) return false;

              return true;
            },
            validCheck : function(){
                if(!this.validId()) return false;

                if(!this.mberInfo. idOvrlpChkAt){
                    this.$toasted.show('아이디 중복확인을 해주세요.');
                    return false;
                }

                if(!this.validPasswd()) return false;

                if(this.mberInfo.password != this.mberInfo.passwordChk){
                  this.$toasted.show("비밀번호가 일치하지 않습니다.");
                  return false;
                }

                if(this.mberInfo.mberNm == ''){
                    this.$toasted.show("성명을 입력해주세요.");
                    return false;
                }

                if(!this.mberInfo.chkCrtfy){
                    this.$toasted.show("휴대폰 인증을 해주세요.");
                    return false;
                }

                if(this.mberInfo.email == ''){
                    this.$toasted.show("이메일을 입력해주세요.");
                    return false;
                }else{
                    const emailValid = /[0-9a-zA-Z][_0-9a-zA-Z-]*@[_0-9a-zA-Z-]+(\.[_0-9a-zA-Z-]+){1,2}$/;
                    if(!emailValid.test(this.mberInfo.email)){
                        this.$toasted.show("올바른 이메일형식을 입력해주세요.");
                        return false;
                    }
                }

                return true;
            },
            btn_joinClick : function(){
                if(!this.validCheck()) return false;
                this.mberInfo.cttpc = this.mberInfo.cttpc1 + '-' + this.mberInfo.cttpc2 + '-' + this.mberInfo.cttpc3;

                this.axios.post('/i5gam/member/join/joinProc.act',{
                    mberInfo : this.mberInfo,
                    rcptnAgreeInfo : this.rcptnAgreeInfo
                }).then(function(response) {
                    const joinProcCode = response.data.joinProcCode;
                    if(joinProcCode == '001'){
                        this.$toasted.show('회원가입이 ' + this.$onbiLib.msg.suc.comp, {duration:1000, type:'success'});
                        
                        if(this.joinCours == 'I5GAMTMP'){   //임시계정으로 가입한 경우 자동 로그인
                            this.$store.dispatch('loginProc', this.mberInfo).then(function(loginProcInfo){
                            const code = loginProcInfo.procCode;

                            if(code == '001'){
                                this.$store.commit('setMberInfo',loginProcInfo.memberInfo);
                            }
                        }).catch(function (e) {
                            console.log(e);
                            this.$toasted.show(this.$onbiLib.msg.err.system);
                        });
                        }
                        this.$router.push({ name: 'views.i5gam.index', params : {callBackSe : this.joinCours}});
                        //join.mode = 'joinComp';
                    }
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    this.$toasted.show(this.$onbiLib.msg.err.system);
                }.bind(this));
            },
            passwdCttpcChk: function (){
              let cttpc = this.mberInfo.cttpc2 + this.mberInfo.cttpc3;
              if (cttpc.length > 7) {
                if (this.mberInfo.password.search(cttpc) > -1) {
                  this.$toasted.show("연락처가 포함된 비밀번호는 사용하실 수 없습니다.");
                  return false;
                }else return true;
              }
              return true;
            },
            passwdIdChk: function (){
              if (this.mberInfo.id.length > 5) {
                if (this.mberInfo.password.search(this.mberInfo.id) > -1) {
                  this.$toasted.show("ID가 포함된 비밀번호는 사용하실 수 없습니다.");
                  return false;
                }else return true;
              }
            },
            passwdRepeatKeyChk: function (){
              if (/(\w)\1\1\1/.test(this.mberInfo.password)) {
                this.$toasted.show('비밀번호에 같은 문자를 4번 연속 사용하실 수 없습니다.');
                return false;
              }else return true;
            },
            passwdCntnKeyChk: function (){
              const max = 4;
              const cntnlimit = ["0123456789", "9876543210",
                "qwertyuiopasdfghjklzxcvbnm",
                "QWERTYUIOPASDFGHJKLZXCVBNM"]
              let Pattern;

              for (let i = 0; i < cntnlimit.length; i++) {
                let check1 = cntnlimit[i];
                let check2 = cntnlimit[i] + cntnlimit[i];
                for (let j = 0; j < check1.length; j++) {
                  let x = check1.substr(j, 1);
                  let y = check2.substr(j, max);
                  Pattern += "[" + x + "]{" + max + ",}|" + y + "|";
                }
              }
              Pattern = new RegExp(Pattern.replace(/.$/, ""));
              if (Pattern.test(this.mberInfo.password)) {
                this.$toasted.show("연속된 숫자와 문자를 4번 연속 사용하실수 없습니다.");
                return false;
              }else return true;
            },
            passwdKnownWordChk: function (){
              const wordLimit = ["love", "LOVE", "happy", "HAPPY", "password", "PASSWORD"
                                , "iloveyou", "ILOVEYOU", "dragon", "DRAGON", "sunshine"
                                , "SUNSHINE", "princess", "PRINCESS", "letmein", "LETMEIN"
                                , "monkey", "MONKEY", "superman", "SUPERMAN", "hello", "HELLO"
                                , "google", "GOOGLE", "apple", "APPLE", "samsung", "SAMSUNG"]
              let msg = '';
              for (let i = 0; i < wordLimit.length; i++) {
                if (this.mberInfo.password.search(wordLimit[i]) > -1) {
                  msg = wordLimit[i];
                }
              }
              if (msg != '') {
                this.$toasted.show("비밀번호에 [" + msg + "]를 사용하실수 없습니다.");
                return false;
              }else return true;
            }
        }
    }

    export default {
        name : 'join',
        mixins : [mixinAgree, mixinInfo],
        data : function(){
            return {
                initAt : true,
                joinCours : '',
                mode : 'joinAgree', //joinAgree : 약관동의, joinInfo : 기본정보 입력
            }
        },
        methods: {
            btn_mainClick: function(){
                if(this.phoneCrtfctn.timer != null && this.phoneCrtfctn.time >0){
                  if(confirm("휴대폰 인증이 취소됩니다. 취소하시겠습니까?")){
                    clearInterval(this.phoneCrtfctn.timer);
                    this.phoneCrtfctn = JSON.parse(JSON.stringify(this.def.phoneCrtfctn));
                  }else {
                    return false;
                  }
                }
                this.$router.push({ name: 'views.i5gam.index'});
            },
            btn_cancelClick: function(){
                if(this.mode == 'joinAgree'){
                    this.$router.push({ name: 'views.i5gam.index'});
                }else if(this.mode == 'joinInfo'){
                    if(this.phoneCrtfctn.timer != null && this.phoneCrtfctn.time >0){
                      if(!confirm("휴대폰 인증이 취소됩니다. 취소하시겠습니까?")){
                        return false;
                      }
                    }
                    clearInterval(this.phoneCrtfctn.timer);
                    this.phoneCrtfctn = JSON.parse(JSON.stringify(this.def.phoneCrtfctn));
                    this.mode = 'joinAgree';
                }
            },
        },
        mounted : function(){
            if(typeof this.$route.params.joinCours != 'undefined'){
                this.joinCours = this.$route.params.joinCours;
                this.mberInfo.mberNo = this.$route.params.mberNo;
            }
        }
    }
</script>

<style scoped>

</style>